import { useQuery } from '@tanstack/react-query'
import { LobsterMasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { labelMasterQueryKeys } from './queryKeys'

export const useQueryLabel = (labelId: string) => {
  return useQuery({
    queryKey: labelMasterQueryKeys.labels.detail(labelId),
    queryFn: () =>
      baseClient.getApi(LobsterMasterApi).getInternalLabel({ id: labelId }),
    retry: 0,
    gcTime: 0,
    throwOnError: true,
  })
}
